import { render, staticRenderFns } from "./PresentButton.vue?vue&type=template&id=cdb37c3c&"
import script from "./PresentButton.vue?vue&type=script&lang=js&"
export * from "./PresentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports